import { jsx } from "react/jsx-runtime";
import "react";
import isEmail from "sane-email-validation";
import TextField from "./TextField.esm.js";
import useConfigWithExtraValidation from "../../utils/form/useExtraFieldValidation.esm.js";
function getInvalidEmailError(value) {
  if (!value) {
    return null;
  }
  const trimmedValue = value.trim();
  if (trimmedValue.length === 0) {
    return null;
  }
  if (trimmedValue.includes(" ")) {
    return "Email address cannot contain spaces";
  }
  const atCount = (trimmedValue.match(/@/g) || []).length;
  if (atCount > 1) {
    return "Invalid email format";
  }
  if (!trimmedValue.includes("@")) {
    return "Please include an @ in the email address";
  }
  const [localPart, domain] = trimmedValue.split("@");
  if (!localPart) {
    return "Please enter a part before @";
  }
  if (!domain) {
    return "Please enter a part following @";
  }
  if (!domain.includes(".")) {
    return "Please include a domain extension (e.g. .com)";
  }
  if (!isEmail(trimmedValue)) {
    return "Invalid email format";
  }
  return null;
}
function EmailField(textFieldProps) {
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...textFieldProps,
      type: "email",
      autoComplete: "email",
      config: useConfigWithExtraValidation(textFieldProps.config, getInvalidEmailError)
    }
  );
}
EmailField.propTypes = TextField.propTypes;
EmailField.defaultProps = TextField.defaultProps;
export {
  EmailField as default,
  getInvalidEmailError
};
